module.exports = __webpack_public_path__ + "static/media/profile_blackwhite.ba781144.png";